import React, { useState,useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { BtnAlmacenar, BtnActualizar,BtnModificar } from "componentes/templates/btn_crud";
import { GET } from 'helpers/request';
import { POST, PUT, DELETE } from 'helpers/request'
import LanguageHelper from 'helpers/language_helper'
import {
  BtnBuscar,
  BtnAnterior,
  BtnSiguiente,
  BtnEliminar,
   MenuCantidad,
} from "componentes/templates/btn_crud";
import ModalContainer from "componentes/templates/modalcontainer";
export default function FormThematics() {

  const [minispiner, setMinispiner] = useState(true)

  let { id } = useParams();
  // Luego de almacenar, debemos regresar a la pantalla anterior con navlink o history
  let history = useHistory();

  /* Arreglo con las variables para colocar los datos en el formulario */
  const variables = [
    "the_txt_name",
    "the_txt_description",
    "the_int_order",
    "the_sts_register",
    "tra_txt_language",
    "tra_txt_table",
    "tra_txt_column",
    "tra_int_idrecord",
    "tra_sts_register",
    "tra_txt_translation",
    "the_txt_image"
  ];

  const [listadoTranslations, setListadoTranslations] = useState(false);
  const [pageTra, setPageTra] = useState(0);
  const [cantidadTra, setCantidadTra] = useState(5);
  const [keyTra, setKeywordsTra] = useState("");
  const [totalTra, setTotalTra] = useState(0);
  const [urlTra, setUrlTra] = useState(
    `indicators/getTranslationsByThematic/${id}?l=${cantidadTra}&o=${pageTra}&k=${keyTra}`
  );
 
  const [actualizar, setActualizar] = useState(false);
  const [disabledName, setDisabledName] = useState(false);
  const gestionarCambio = (event) => {
    if (event.target.type === "radio") {
      localStorage.setItem(event.target.name, event.target.value);
    } else {
      localStorage.setItem(event.target.id, event.target.value);
    }
  };

  const actualizarElemento =  async (e) => {
    e.preventDefault();
    try {
      const data = await PUT(variables, "indicators/thematics",id);
      // console.log(res);
      Verificar(data);
      
    } catch (error) {
      console.log("error", error)
    }
   
  };


  const Verificar = (result) => {
    let resultado = result;
    if (resultado.status === 201) {
      alert(resultado.messages);
      // limpiar el storage
      variables.forEach(function (valor) {
        localStorage.removeItem(valor);
      });
      history.push("/intranetIndicators/thematicsList/"+ resultado.id);
      
      window.location.reload();
      
    } else {
      // regresó error (normalmente 400), no pasó la validación
      variables.forEach(function (valor) {
        // es el mensaje de error q devuelve la validacion del codeigniter
        if (document.getElementById(valor + "_msj") !== null) {
          let mensaje = resultado[valor];
          document.getElementById(valor + "_msj").classList.remove("is-hidden");
          document.getElementById(valor + "_msj").textContent = mensaje;
        }

      });
    }
  };

  const colocar = (result) => {
    let resultado = result;
    //console.log("Variables %c"+variables,"color:green")
    variables.forEach(function (i) {
      if( i!== "tra_txt_language" &&  i!== "tra_txt_translation" && document.getElementById(i)!=null)
      {
        document.getElementById(i).value = resultado[i];
      }
      if( i!== "tra_txt_language" &&  i!== "tra_txt_translation" )
      {
        localStorage.setItem(i, resultado[i]);
      }
        setMinispiner(false)
    });
  };

  const gAlmacenar = async (e) => {
    e.preventDefault();
    localStorage.setItem("tra_txt_language", sessionStorage.getItem('languageId'));
    localStorage.setItem("tra_txt_table", "aro.aro_thematics");
    localStorage.setItem("tra_txt_column", "the_txt_name");
   
    try {
      const data = await POST(variables, "indicators/thematics");
      // console.log(res);
      Verificar(data);
      
    } catch (error) {
      console.log("error", error)
    }
  };

  const prepararTranslations = (result) => {
    var resultados = result;

    var notes = resultados.datos;
    setTotalTra(resultados.total);

    const gestionarEliminar = async (id) => {

      try {
       await DELETE("indicators/translations/",id);
        // console.log(res);
        setActualizar(true);
        
      } catch (error) {
        console.log("error ELIMINAR", error)
      }

     
    };

    const listaItems = notes.map((item) => {
      return (
        <tr key={"tra_" + item.tra_int_id}>
          <td>{item.tra_txt_translation}</td>
          <td>{item.tra_txt_language}</td>

          <td>
            <BtnModificar className="is-spaced" id={item.tra_int_id} nameE={"intranetIndicators/translationsList"} />
            <BtnEliminar gestionarEliminar={() => gestionarEliminar(item.tra_int_id)} />
          </td>
        </tr>
      );
    });
   
    setListadoTranslations(listaItems);
  };

  const gestionarAnteriorTra = () => {
    let desde = (pageTra - 1) * cantidadTra;
    if (desde >= 0) {
      setPageTra(pageTra - 1);
      setUrlTra(
        `indicators/getTranslationsByThematic/${id}?l=${cantidadTra}&o=${desde}&k=${keyTra}`
      );
    }
  };

  const gestionarCantidadTra = (event) => {
    event.preventDefault();
    setCantidadTra(event.target.value);
    setUrlTra(
      `indicators/getTranslationsByThematic/${id}?l=${event.target.value}&o=${pageTra}&k=${keyTra}`
    );
  };


  const gestionarSiguienteTra = () => {
    let desde = (pageTra + 1) * cantidadTra;
    if (desde < totalTra) {
      setPageTra(pageTra + 1);
      setUrlTra(
        `indicators/getTranslationsByThematic/${id}?l=${cantidadTra}&o=${desde}&k=${keyTra}`
      );
    }
  };

  const gestionarBuscarTra = (event) => {
    event.preventDefault();
    setPageTra(0);
    setUrlTra(
      `indicators/getTranslationsByThematic/${id}?l=${cantidadTra}&o=${pageTra}&k=${keyTra}`
    );
  };

  const obtenerFiltroTra = (event) => {
    setKeywordsTra(event.target.value);
  };

useEffect(() => {
  if (id !== "0") {
    const fetcher = async () => {
      const list = await GET(`indicators/thematics/${id}`);
      list.error ? console.log("error useEffect ", list.error) : colocar(list);

    };
    fetcher();

    const fetcherTra = async () => {
      const list = await GET(urlTra);
      list.error ? console.log("error useEffect ", list.error) : prepararTranslations(list);

    };
    fetcherTra();
    setDisabledName(true);

  }else{
    variables.forEach(function (valor) {
      localStorage.removeItem(valor);
    });
    setMinispiner(false)
  }
  // eslint-disable-next-line
}, [urlTra, actualizar])

  return (
    <div className="container is-fluid">
      <div className="columns">
        <div className="column is-9 is-offset-1">
          <h3 className="title is-3">
            {id === "0" ? LanguageHelper.getLanguageString('ThematicsForm.Title.add') : LanguageHelper.getLanguageString('ThematicsForm.Title.upd')}
          </h3>

          <form autoComplete="nope">
            {disabledName?"":
            <div className="field">
            <label className="label">{LanguageHelper.getLanguageString('ThematicsForm.name')}</label>
            <div className="control has-icons-left">
              <input
                type="text"
                placeholder={LanguageHelper.getLanguageString('ThematicsForm.name')}
                className="input"
                id="the_txt_name"
                required
                onChange={gestionarCambio}
                maxLength="128"
               
              />
              <span className="icon is-small is-left">
                <i className={(minispiner) ? "fa fa-cog fa-spin" : "fas fa-users"}></i>
              </span>
            </div>
            <p
              className="is-hidden help is-danger"
              id="the_txt_name_msj"
            ></p>
          </div>
            }
            

            <div className="field">
              <label className="label">{LanguageHelper.getLanguageString('ThematicsForm.description')}</label>
              <div className="control has-icons-left">
                <input
                  type="text"
                  placeholder={LanguageHelper.getLanguageString('ThematicsForm.description')}
                  className="input"
                  id="the_txt_description"
                  required
                  onChange={gestionarCambio}
                />
                <span className="icon is-small is-left">
                  <i className={(minispiner) ? "fa fa-cog fa-spin" : "fas fa-users"}></i>
                </span>
              </div>
              <p className="is-hidden help is-danger" id="the_text_description_msj"></p>
            </div>

            <div className="field">
              <label className="label">{LanguageHelper.getLanguageString('ThematicsForm.order')}</label>
              <div className="control has-icons-left">
                <input
                  type="number"
                  placeholder="Orden"
                  className="input"
                  id="the_int_order"
                  required
                  onChange={gestionarCambio}
                  min="1"
                />
                <span className="icon is-small is-left">
                  <i className={(minispiner) ? "fa fa-cog fa-spin" : "fas fa-users"}></i>
                </span>
              </div>
              <p className="is-hidden help is-danger" id="the_int_order_msj"></p>
            </div>

            <div className="field">
              <label className="label">{LanguageHelper.getLanguageString('FormThematics.icon')}</label>
              <div className="control has-icons-left">
                <input
                  type="text"
                  placeholder={LanguageHelper.getLanguageString('FormThematics.icon')}
                  className="input"
                  id="the_txt_image"
                  required
                  onChange={gestionarCambio}
                  maxLength="1024"
                   />
                <span className="icon is-small is-left">
                  <i className={(minispiner) ? "fa fa-cog fa-spin" : "fas fa-users"}></i>
                </span>
              </div>
              <p className="is-hidden help is-danger" id="the_txt_image_msj"></p>
            </div>

           
            
            {id === "0" ? (
              <BtnAlmacenar gAlmacenar={gAlmacenar}>{LanguageHelper.getLanguageString('ThematicsForm.save')}</BtnAlmacenar>
            ) : (
              <BtnActualizar actualizarElemento={actualizarElemento}>
                {LanguageHelper.getLanguageString('ThematicsForm.update')}
              </BtnActualizar>
            )}
          </form>
        </div>
        

      </div>
      {
          id !== "0" ? (
            <>
              <div className="message is-success">
                <div className="column is-9 is-offset-1">
                  <div className="field">
                    <div className="message-header">
                      <p>{LanguageHelper.getLanguageString('TranslationThematics.Title')}</p>
                    </div>

                  </div>
                  <div className="columns">
                    <div className="column is-9 is-offset-1">
                      <form onSubmit={gestionarBuscarTra}>
                        <div className="field has-addons">
                          <div className="control has-icons-left has-icons-right">
                            <input
                              className="input"
                              type="text"
                              name="k"
                              id="k"
                              placeholder={LanguageHelper.getLanguageString('TranslationThematics.placeholder')}
                              onChange={obtenerFiltroTra}
                            />
                            <span className="icon is-small is-left">
                              <i className="fas fa-key"></i>
                            </span>
                          </div>
                          <div className="control">
                            <BtnBuscar />
                          </div>
                        </div>
                      </form>
                    </div>
                    <div className="column is-2">
                      <ModalContainer modalTitle={LanguageHelper.getLanguageString('TranslationForm.add')} info_component="tra" ind_int_id={id} save={null} labelClose={LanguageHelper.getLanguageString('TranslationForm.close')} tableT="aro.aro_thematics" />
                    </div>
                    
                  </div>

                  <div className="columns">
                    <div className="column is-10 is-offset-1">
                      <div className="table-container">
                        <table className="table is-striped is-bordered is-hoverable is-fullwidth">
                          <thead>
                            <tr>


                              <th>{LanguageHelper.getLanguageString('TranslationThematics.translation')}</th>
                              <th>{LanguageHelper.getLanguageString('TranslationThematics.language')}</th>
                              <th>{LanguageHelper.getLanguageString('TranslationThematics.options')}</th>
                            </tr>
                          </thead>
                          <tbody>{listadoTranslations}</tbody>
                          <tfoot>
                            <tr>
                              <td colSpan="1" className="has-text-centered">
                                {pageTra > 0 ? (
                                  <BtnAnterior gestionarAnterior={gestionarAnteriorTra} />
                                ) : (
                                    <BtnAnterior gestionarAnterior={null} />
                                  )}

                                <MenuCantidad
                                  className=""
                                  gestionarCantidad={gestionarCantidadTra}
                                  total={totalTra}
                                  can={cantidadTra}
                                />

                                {(pageTra + 1) * cantidadTra < totalTra ? (
                                  <BtnSiguiente gestionarSiguiente={gestionarSiguienteTra} />
                                ) : (
                                    <BtnSiguiente gestionarSiguiente={null} />
                                  )}
                              </td>
                              <td>{LanguageHelper.getLanguageString('TranslationThematics.total')}: {totalTra}</td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>

          ) : ('')
        }
    </div>
  );
}
